// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2kxzc","Success":"Button_Success__1O96J","Danger":"Button_Danger__1qhNV"};